module.exports = __webpack_public_path__ + "img/official_show_back.3f76dbc5.jpg";